import React, { useState, useEffect } from 'react';
import { compose } from 'redux';
import Select from 'react-dropdown-select';
import CustomContentRenderer from './DropDownContainer';
import Search from './Search';
import DropDownList from './DropDownList';
import { filterOnMultipleFields } from '../../helpers/arrayHelpers';
import { withSelectedCategoriesActions } from '../../hocs/withActions';

const CustomContentAndDropdown = ({
  options = [],
  searchBy = '',
  searchById = '',
  valueField = '',
  onSelect = () => { },
  SaveSelectedCategories = () => { },
}) => {
  const [clearableState, setClearableState] = useState(false);
  const [openDropdown, setOpenDropdownState] = useState('close');

  const handleClassName = () => setOpenDropdownState('open');
  const handleClassNameClose = () => setOpenDropdownState('close');

  const contentRenderer = ({ state }) => {
    return (
      <CustomContentRenderer
        state={state}
        onSelectedChanged={setClearableState}
      />
    )
  };

  const CustomDropdownRenderer = ({ props, state, methods }) => {
    const regexp = new RegExp(state.search, 'i');
    const filteredOptions = filterOnMultipleFields(options, [props.labelField, props.idField], regexp);
    const { values = [] } = state;
    useEffect(() => {
      SaveSelectedCategories(values);
      onSelect(values);
    }, [values]);

    return (
      <>
        <Search
          value={state.search}
          onSearch={methods.setSearch}
        />
        <DropDownList
          options={filteredOptions}
          addItem={methods.addItem}
          selectedValues={state.values}
        />
      </>
    );
  };

  return (
    <div className={`dropdown-container ${openDropdown}`}>
      <Select
        className="dropdown"
        options={options}
        contentRenderer={contentRenderer}
        dropdownRenderer={CustomDropdownRenderer}
        multi
        searchable
        clearOnSelect={false}
        clearable={clearableState}
        values={[]}
        onDropdownOpen={handleClassName}
        onDropdownClose={handleClassNameClose}
        labelField={searchBy}
        idField={searchById}
        valueField={valueField}
      />
    </div>
  );
};

CustomContentAndDropdown.propTypes = {};

export default compose(
  withSelectedCategoriesActions,
)(CustomContentAndDropdown);
